import React, { useState, useEffect, useMemo } from 'react'
import Modal from 'react-bootstrap/Modal';
import ReactDataTableBootstrap from '../../Components/ReactDataTableBootstrap/ReactDataTableBootstrap';
import Controllers from '../../Api/Controllers';
import VideoForm from './VideoForm'
import VideoAdditional from './VideoAdditional'
import { toast } from 'react-toastify';
import Helpers from '../../Components/Helpers/Helpers';
import SweetAlert from '../../Components/SweetAlert/SweetAlert'
import { StatusPill, ActionIconButton, ListPageShell, SideDrawer, EmptyState } from '../../Components/Ui'

const Video = ({ nameSingle, namePlural, separator }) => {
    const [isProcessing, setIsProccesing] = useState(true)
    const [modalShow, setModalShow] = useState(false);
    const [modalTitle, setModalTitle] = useState('');
    const [reload, setReload] = useState(true);
    const [rows, setRows] = useState([])
    const [loadSubmit, setLoadSubmit] = useState(false)
    const [dataUpdated, setDataUpdated] = useState({})
    const [showConfirmDelete, setShowConfirmDelete] = useState(false)
    const [loadSubmitDelete, setLoadSubmitDelete] = useState(false)
    const [dataDeleted, setDataDeleted] = useState({})
    const [localSearch, setLocalSearch] = useState('')
    const [tableFilter, setTableFilter] = useState('')

    const [modalTitleFile, setModalTitleFile] = useState('');
    const [modalShowFile, setModalShowFile] = useState(false);
    const [loadSubmitFile, setLoadSubmitFile] = useState(false)
    const [dataUpdatedFile, setDataUpdatedFile] = useState({})
    const [percentageUpload, setPercentageUpload] = useState(0)

    useEffect(() => {
        if (reload) {
            setIsProccesing(true)
            Controllers.video.get_video().then(res => {
                setRows(res.data)
            }).catch(req => Helpers.promise.catch({ req, toast }))
            .finally(() => {
                setIsProccesing(false)
                setReload(false)
            })
        }
    }, [reload])

    const handleInsertUpdate = ({ data }) => {
        setLoadSubmit(true)
        Controllers.video.video_insert_update({
            data,
            onUploadProgress: ({ currentProgress }) => {
                setDataUpdated({ ...dataUpdated, percentageUpload: currentProgress })
            }
        }).then(res => {
            Helpers.toast.construct({ ...res, toast })
            if (res.response === 'success') {
                setModalShow(false)
                setDataUpdated({})
            }
        }).catch(req => Helpers.promise.catch({ req, toast }))
        .finally(() => {
            setLoadSubmit(false)
            setReload(true)
            setDataUpdated({ ...dataUpdated, percentageUpload: 0 })
        })
    }

    const handleGet = e => {
        let $this = e.currentTarget

        if (!$this.dataset?.idVideo) {
            setModalTitle(`Registrar ${nameSingle}`)
            setDataUpdated({
                percentageUpload
            })
            setModalShow(true);
            return
        }

        let buttonHTML = $this.innerHTML;
        $this.innerHTML = '<i class="fa fa-circle-notch fa-spin"></i>'
        let { idVideo } = $this.dataset

        Controllers.video.get_video_id({ p_id_video: idVideo }).then(res => {
            setModalTitle(`Modificar ${nameSingle} #${idVideo}`)
            setDataUpdated({ data: res.data, percentageUpload })
            setModalShow(true);
        }).catch(req => {
            Helpers.promise.catch({ req, toast })
            setReload(true)
        })
        .finally(() => $this.innerHTML = buttonHTML)
    }

    const handleOpenCreate = () => {
        setModalTitle(`Registrar ${nameSingle}`)
        setDataUpdated({ percentageUpload })
        setModalShow(true)
    }

    const handleDelete = () => {
        setLoadSubmitDelete(true)

        Controllers.video.video_delete(dataDeleted).then(res => {
            Helpers.toast.construct({ ...res, toast })
            if (res.response === 'success') {
                setShowConfirmDelete(false)
                setDataDeleted({})
            }
        }).catch(req => Helpers.promise.catch({ req, toast }))
        .finally(() => {
            setReload(true)
            setLoadSubmitDelete(false)
        })
    }

    const handleHideModalForm = () => {
        setModalShow(false)
        setLoadSubmit(false)
    }

    const handleShowModalDelete = e => {
        let { idVideo, nameVideo } = e.currentTarget.dataset
        setDataDeleted({
            p_id_video: idVideo,
            p_name_video: nameVideo
        })
        setShowConfirmDelete(true)
    }

    const handleHideModalDelete = () => setShowConfirmDelete(false)

    const addContentAdditional = e => {
        let { idVideo } = e.currentTarget.dataset
        setDataUpdatedFile({ idVideo })
        setModalShowFile(true)
        setModalTitleFile(<><i className="fa fa-plus mr-1"></i>Agregar Material Adicional a Video # {idVideo}</>)
    }

    const handleHideModalFormFile = () => {
        setModalShowFile(false)
        setLoadSubmitFile(false)
    }

    const applySearch = () => setTableFilter(localSearch)

    const dtRows = useMemo(() => <ReactDataTableBootstrap
        textFilter={tableFilter}
        hideSearch
        head={[
            [
                { name: 'id_video', text: 'ID', align: 'center' },
                { name: 'name_video', text: 'Descripción' },
                { name: 'file_images', text: 'Imagen Destacada', align: 'center', render: r => <img className="img-thumbnail" src={Helpers.config.resourcesUrl({ url: r.file_images })} height="100" width="100" /> },
                /* { name: 'name_category', text: 'Departamento' }, */
                { name: 'status_video', text: 'Estado', align: 'center', render: r => <StatusPill tone={parseInt(r.status_video) === 1 ? 'success' : 'danger'}>
                    {parseInt(r.status_video) === 1 ? 'Activo' : 'Inactivo'}
                </StatusPill> },
                { name: 'actions', text: 'Acciones', align: 'center', render: u => {
                    return <div className="sp-row-actions">
                        <ActionIconButton tone="ghost" icon="fa fa-pen" label="Editar" data-id-video={u.id_video} onClick={handleGet} />
                        <ActionIconButton tone="danger" icon="fa fa-trash" label="Eliminar" data-id-video={u.id_video} data-name-video={u.name_video} onClick={handleShowModalDelete} />
                        <ActionIconButton tone="secondary" icon="fa fa-file" label="Material" data-id-video={u.id_video} onClick={addContentAdditional} />
                    </div>
                } },
            ],
        ]}
        rows={rows}
        isProcessing={isProcessing}
    />, [rows, isProcessing, tableFilter])

    const showEmpty = !isProcessing && rows.length === 0

    return <>
        <ListPageShell
            eyebrow="Super Papelera — Espacio de trabajo"
            title={`Listado de ${namePlural}`}
            subtitle="Consulta y administra los videos y su material adicional."
            badge="Actividad actualizada"
            primaryAction={
                <ListPageShell.PrimaryButton onClick={handleOpenCreate} icon="fa fa-plus">
                    Registrar {nameSingle}
                </ListPageShell.PrimaryButton>
            }
            onSearch={applySearch}
            filters={[
                {
                    label: 'Buscar',
                    control: (
                        <input
                            type="search"
                            placeholder="Video…"
                            value={localSearch}
                            onChange={e => setLocalSearch(e.target.value)}
                            onKeyDown={e => { if (e.key === 'Enter') applySearch() }}
                        />
                    )
                }
            ]}
        >
            {showEmpty ? (
                <EmptyState
                    icon="fa fa-video"
                    title={`No hay ${namePlural.toLowerCase()} para mostrar`}
                    text="Ajusta la búsqueda o registra un nuevo video para empezar."
                    action={
                        <ListPageShell.PrimaryButton onClick={handleOpenCreate}>
                            Registrar {nameSingle}
                        </ListPageShell.PrimaryButton>
                    }
                />
            ) : (
                <div className="sp-table-wrap">{dtRows}</div>
            )}
        </ListPageShell>

        <SideDrawer
            open={modalShow}
            onClose={handleHideModalForm}
            title={modalTitle}
            subtitle="Los cambios se guardan al confirmar el formulario."
        >
            <VideoForm onSubmit={handleInsertUpdate} loadSubmit={loadSubmit} {...dataUpdated} />
        </SideDrawer>

        <Modal show={modalShowFile} onHide={handleHideModalFormFile} backdrop="static" size="lg">
            <Modal.Header closeButton>
                <Modal.Title as="div">{modalTitleFile}</Modal.Title>
            </Modal.Header>
            <Modal.Body>
                <VideoAdditional nameSingle="Material Adicional" namePlural="Materiales Adicionales" separator="el" loadSubmit={loadSubmitFile} {...dataUpdatedFile} />
            </Modal.Body>
        </Modal>

        <SweetAlert
            icon="delete"
            show={showConfirmDelete}
            showCancelButton
            title={<>¿Desea eliminar {separator} {nameSingle}?</>}
            subtitle={<>#{dataDeleted.p_id_video} - {dataDeleted.p_name_video}</>}
            confirmButtonText="¡Sí, eliminar!"
            cancelButtonText="¡No!"
            loadSubmit={loadSubmitDelete}
            onCancel={handleHideModalDelete}
            onConfirm={handleDelete}
        />
    </>
}

export default Video
